import React, { useEffect, useState } from 'react';
import { CONTACT_INFO, PIZZERIA_NAME } from '../../constants';

const Navbar = ({ currentRoute, onNavigate }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 24);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const navLinks = [
    {
      name: 'Speisekarte',
      target: 'speisekarte',
      isActive: currentRoute === '/',
    },
    {
      name: 'Über uns',
      target: 'ueberUns',
      isActive: currentRoute === '/ueber-uns',
    },
    {
      name: 'Kontakt',
      target: 'kontakt',
      isActive: currentRoute === '/kontakt',
    },
  ];

  const handleNavigation = (target) => {
    onNavigate(target);
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed inset-x-0 top-0 z-50 px-4 pt-0 transition-all duration-300 sm:px-6 lg:px-8">
      <div
        className={`mx-auto flex max-w-7xl items-center justify-between gap-6 rounded-[1.75rem] border px-6 py-4 shadow-[0_18px_50px_rgba(28,25,23,0.14)] transition-all duration-300 lg:px-8 ${
          isScrolled
            ? 'border-stone-200 bg-[rgba(255,252,248,0.97)] backdrop-blur-xl'
            : 'border-white/70 bg-[rgba(255,254,251,0.9)] backdrop-blur-lg'
        }`}
      >
        <button
          type="button"
          className="text-left"
          onClick={() => handleNavigation('home')}
        >
          <span className="mt-1.5 block text-xl font-semibold tracking-tight text-stone-950 sm:text-[1.95rem]">
            {PIZZERIA_NAME}
          </span>
        </button>

        <nav className="hidden items-center gap-3 md:flex">
          {navLinks.map((link) => (
            <button
              key={link.name}
              type="button"
              onClick={() => handleNavigation(link.target)}
              aria-current={link.isActive ? 'page' : undefined}
              className={`rounded-full px-4 py-2.5 text-lg font-semibold transition ${
                link.isActive
                  ? 'bg-orange-600 text-white shadow-[0_10px_24px_rgba(234,88,12,0.22)] hover:bg-orange-600 hover:text-white'
                  : 'text-stone-800 hover:bg-orange-50 hover:text-orange-700'
              }`}
            >
              {link.name}
            </button>
          ))}
        </nav>

        <div className="hidden items-center gap-4 md:flex">
          <a
            href={CONTACT_INFO.phoneHref}
            className="rounded-full bg-emerald-600 px-6 py-3 text-base font-semibold text-white transition hover:bg-emerald-700"
          >
            {CONTACT_INFO.phone}
          </a>
        </div>

        <button
          type="button"
          onClick={() => setIsMenuOpen((open) => !open)}
          className="inline-flex h-12 w-12 items-center justify-center rounded-full border border-stone-300 bg-white text-stone-900 shadow-sm md:hidden"
          aria-expanded={isMenuOpen}
          aria-label="Navigation öffnen"
        >
          <svg
            className="h-5 w-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d={
                isMenuOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 7h16M4 12h16M4 17h16'
              }
            />
          </svg>
        </button>
      </div>

      {isMenuOpen ? (
        <div className="mx-auto mt-3 max-w-7xl rounded-[1.5rem] border border-stone-200 bg-[rgba(255,253,249,0.98)] px-6 py-5 shadow-[0_18px_45px_rgba(28,25,23,0.12)] backdrop-blur md:hidden">
          <nav className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <button
                key={link.name}
                type="button"
                onClick={() => handleNavigation(link.target)}
                aria-current={link.isActive ? 'page' : undefined}
                className={`rounded-2xl px-4 py-3 text-left text-xl font-semibold shadow-sm ${
                  link.isActive
                    ? 'bg-orange-600 text-white shadow-[0_10px_24px_rgba(234,88,12,0.22)] hover:bg-orange-600 hover:text-white'
                    : 'bg-white text-stone-800'
                }`}
              >
                {link.name}
              </button>
            ))}
            <a
              href={CONTACT_INFO.phoneHref}
              className="rounded-2xl bg-emerald-50 px-4 py-3 text-xl font-semibold text-emerald-800"
            >
              {CONTACT_INFO.phone}
            </a>
          </nav>
        </div>
      ) : null}
    </header>
  );
};

export default Navbar;
